/* eslint-disable react/no-array-index-key */
import React from "react";
import Skeleton from "react-loading-skeleton";

function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function TableSkeleton() {
  return (
    <div className="pp_comms_parent">
      <div className="pp_comms_section_header">Triggers</div>
      <div className="pp_comms_table">
        <div className="pp_comms_table__selector">0 selected out of 16</div>
        <div className="pp_comms_table__header">
          <input type="checkbox" />
          <div className="pp_comms_table__header_name pp_comms_table__header_name--name">
            <span>Name</span>
            <span className="pp_comms_table__arrow-up" />
          </div>
          <div className="pp_comms_table__header_name pp_comms_table__header_name--category">
            <span>Category</span>
            <span className="pp_comms_table__arrow-up" />
          </div>
          <div className="pp_comms_table__header_name pp_comms_table__header_name--status">
            <span>Status</span>
            <span className="pp_comms_table__arrow-up" />
          </div>
        </div>
        {Array.from(Array(16).keys()).map((item, index) => {
          return (
            <div key={`${item}-${index}`} className="pp_comms_table__lineitem">
              <span className="pp_comms_table__lineitem_name pp_comms_table__lineitem_name--name">
                <Skeleton width={randomIntFromInterval(300, 400)} />
              </span>
              <span className="pp_comms_table__lineitem_name pp_comms_table__lineitem_name--category">
                <Skeleton width={randomIntFromInterval(100, 120)} />
              </span>
              <div className="pp_comms_table__lineitem_name pp_comms_table__lineitem_name--status">
                <span className="pp_comms_table__status pp_comms_table__status--inactive">
                  <Skeleton width={15} />
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TableSkeleton;
